import { useContext, useEffect, useRef, useState } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { AiFillCheckCircle, AiFillHeart } from 'react-icons/ai';
import { FaLink } from 'react-icons/fa';
import { HiArrowNarrowRight } from 'react-icons/hi';
import { HiFolderArrowDown } from 'react-icons/hi2';
import { useLocation } from 'react-router-dom';
import style from './detailBoard.module.css';
import {
    cameraParamsAtom,
    cardsAtom,
    logInfoAtom,
    meshProfileAtom,
    posterGenerateAtom,
    showDownloadAtom,
    showLoginAtom,
    showPayCardAtom,
    showProgressAtom,
    showSharePopupAtom,
    stopChatAtom,
    taskDetailAtom,
    packingStateAtom,
    progressCheckingQueueAtom,
    isPurchasedAtom,
    packInfoAtom,
    modalObjAtom,
    // subscriptionsInfoAtom,
    showSubscribeAtom,
    userPermissionAtom,
    // showReferralAtom,
} from '../../../store';
import { likeCard } from '../../../utils/net';
import { global_render_target_injector, load_profile } from '../../../render/sssss_rendering';
// import { exportToImage, } from '../../../utils/format';
import Private from '../../widgets/Private';
import License from '../../widgets/License';
import ShareRender from '../../../common/SharePoster';
import { useTips } from '../../../common/GlobalTips';
import { BundlePanelFade } from '../BundlePanelFade';
import { BundlePanel } from '../BundlePanel';
import { useDebounce } from '../../../utils/hooks';
import { trackEvent } from '../../../utils/trackEvent'
import { AvatarImage } from '../../../common/AvatarImage';
import { ModelLoading } from '../../../common/ModelLoading';
import deletWights from '../../../assets/deletWights.png'
import * as Sentry from "@sentry/react";
import { useTranslation } from "react-i18next";
import { PermissionContext } from '../../../utils/context';

const CreatorInfo = () => {
    const logInfo = useRecoilValue(logInfoAtom);
    const taskDetail = useRecoilValue(taskDetailAtom);
    return (
        <div className={style.creatorBox}>
            <div className={style.avatar}>
                {taskDetail ? <AvatarImage url={taskDetail?.author?.avatar_url} /> : null}
            </div>
            <div className={style.creatorInfoCon}>
                <div className={style.creatorName}>
                    {taskDetail?.author?.username}
                </div>
                <div className={style.creatorInfo}>
                    {logInfo.is_admin ? taskDetail?.author?.email : null}
                </div>
            </div>
        </div>
    )
}

const ToolBar = ({ handleLike, isLike, showSharePopup, setShowSharePopup }) => {
    const taskDetail = useRecoilValue(taskDetailAtom);
    const isPurchased = useRecoilValue(isPurchasedAtom);
    const packInfo = useRecoilValue(packInfoAtom);
    const logInfo = useRecoilValue(logInfoAtom);
    const setPosterGenerate = useSetRecoilState(posterGenerateAtom);
    const setShowLogin = useSetRecoilState(showLoginAtom);
    const [isShared, setIsShared] = useState(false);
    const [showDownload, setShowDownload] = useRecoilState(showDownloadAtom);
    const tip = useTips();
    const downloadBtnRef = useRef(null);
    const BundlePanelRef = useRef(null);
    const { t } = useTranslation();

    useEffect(() => {
        return () => {
            setIsShared(false);
        }
    }, [])

    useEffect(() => {
        if (showSharePopup) {
            document.addEventListener('mousedown', handleOutsideClick);
        } else {
            document.removeEventListener('mousedown', handleOutsideClick);
        }

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };

    }, [showSharePopup]);

    useEffect(() => {
        const handleClick = (e) => {
            if (BundlePanelRef.current
                && !BundlePanelRef.current.contains(e.target)
                && downloadBtnRef.current
                && !downloadBtnRef.current.contains(e.target)) {
                setShowDownload(false);
            }
        };
        if (showDownload) {
            document.addEventListener('mousedown', handleClick);
        } else {
            document.removeEventListener('mousedown', handleClick);
        }
        return () => {
            document.removeEventListener('mousedown', handleClick);
        };

    }, [showDownload]);

    const handleShare = async () => {
        _czc.push(['_trackEvent', 'Card', 'Share Icon', 'Detail Card']);
        try {
            setPosterGenerate(true);
            const url = `${window.location.origin}/${location.pathname.includes('/imageto3d') ? 'imageto3d/' : 'chatavatar/'
                }${taskDetail.task_uuid}`;

            if (navigator.clipboard) {
                await navigator.clipboard.writeText(url);
            } else {
                const textarea = document.createElement('textarea');
                if (document.body) {
                    document.body.appendChild(textarea);
                    textarea.style.position = 'fixed';
                    textarea.zIndex = -999;
                    textarea.style.top = '10px';
                    textarea.value = url;
                    textarea.select();
                    document.execCommand('copy', true);
                    document.body.removeChild(textarea);
                }
            }
            setIsShared(true);
            setShowSharePopup(true);
            setTimeout(() => {
                setIsShared(false);
            }, 1500);
        } catch (e) {
            Sentry.captureException(e)
        }
    };

    const handleDownloadBtnClick = async () => {
        _czc.push(['_trackEvent', 'Card', 'Pack Icon', 'Detail Card']);
        if (!logInfo) {
            setShowLogin(true);
            return;
        }

        if (taskDetail.user_state === 'None') {
            tip({
                type: 'info',
                content: t('TIP_INFO_PERMISSION_DENIED'),
            });
            return;

        }
        trackEvent('ChatAvatar - Card - Download Page', { open:!showDownload }, taskDetail.task_uuid)
        setShowDownload(!showDownload);
    };

    const handleOutsideClick = (e) => {
        const twitterElement = document.getElementById('twitter-share-button')
        if (twitterElement && twitterElement.contains(e.target)) {
            return;
        }
        setShowSharePopup(false);
    };

    if (!taskDetail) {
        return null
    }
    return (
        <div className={style.iconWrapper}>
            {/* share */}
            {isShared ? (
                <div className={`${style.shareCon} ${isShared ? style.shared : style.unshared
                    }`}>
                    <AiFillCheckCircle
                        style={{ color: 'green', fontSize: '22px' }}
                    />
                    <div className={`${style.hideOnSmallScreen}`} style={{ width: '71px' }}>
                        &nbsp;&nbsp;{t('BUTTON_COPIED')}
                    </div>
                </div>
            ) : (
                <div
                    className={style.shareCon}
                    onClick={handleShare}
                >
                    <FaLink style={{ fontSize: '22px', color: '#d5d5d5' }} />
                    <div className={`${style.hideOnSmallScreen}`} style={{ width: '71px' }}>&nbsp;{t('BUTTON_SHARE')}&nbsp;</div>
                </div>
            )}
            {/* download */}
            {isPurchased && <div
                ref={downloadBtnRef}
                className={`${['DoneHigh', 'DoneBasic', 'Generating'].includes(packInfo.details.user_state)
                    ? style.titleBtnSuccess
                    : style.titleBtn
                    }  
                                    ${style.downloadBtn} 
                                    ${showDownload ? style.download : style.undownload}
                                    `}
                onClick={handleDownloadBtnClick}
            >
                <HiFolderArrowDown
                    style={{ color: '#d5d5d5', fontSize: '23px' }}
                />
            </div>}
            {/* like设置 */}
            <div
                className={`${style.titleBtn} ${isLike ? style.like : style.unLike
                    } `}
                onPointerDown={handleLike}
            >
                {isLike ? (
                    <AiFillHeart style={{ color: 'red', fontSize: '23px' }} />
                ) : (
                    <AiFillHeart
                        style={{ color: 'rgb(206, 206, 206)', fontSize: '23px' }}
                    />
                )}
            </div>
            {/* private设置 */}
            {taskDetail.author.user_uuid
                === localStorage.getItem('user_uuid') && (
                    <div className={style.titleBtn}>
                        <Private card={{ ...taskDetail }} type="detail" />
                    </div>
                )}
            <div className={`${showDownload ? style.show : style.hide}`}>
                <BundlePanel ref={BundlePanelRef} onLikeChange={handleLike} />
            </div>
            {/* {showDownload ?  : null} */}
        </div>
    )
}

const NoPack = ({ showPayCard, setShowPayCard, handleLike }) => {
    const logInfo = useRecoilValue(logInfoAtom);
    const setShowLogin = useSetRecoilState(showLoginAtom);
    const { t } = useTranslation();

    const handlerShowCard = () => {
        if (!logInfo) {
            setShowLogin(true);
            return;
        }
        setShowPayCard(true);
    };

    return (
        <div className={style.packBoxView}>
            <GeneralUserTipBox />
            <div
                className={`${style.packBox} ${showPayCard ? style.fadeOut : ''}`}
            >
                <div className={style.permissionDenied}>
                    {t('CHATAVATAR_BOARD_IMGTO3D_PACK_TITLE')}?
                </div>
                <div className={style.purchaseInfo}>
                    {t('CHATAVATAR_BOARD_IMGTO3D_PACK_SUB_TITLE')}
                </div>
                <div className={style.assetsBox}>
                    <div className={style.assets}>{t('CHATAVATAR_BOARD_IMGTO3D_PACK_ASSETS')}</div>
                    <div className={style.assetsHoverInfo}>
                        {t('CHATAVATAR_BOARD_IMGTO3D_PACK_ASSETS_TIPS_1')},
                        {' '}
                        <a
                            href="https://creativecommons.org/licenses/by-nc-sa/4.0/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            {t('CHATAVATAR_BOARD_IMGTO3D_PACK_ASSETS_TIPS_2')}.
                        </a>
                    </div>
                </div>
                <div className={style.packWrapper}>
                    <div className={style.arrowWrapper} onClick={handlerShowCard}>
                        <div className={style.arrowIconBox}>
                            <HiArrowNarrowRight color="#fff" fontSize="18px" />
                        </div>
                        <div className={style.packNow}>{t('CHATAVATAR_BOARD_IMGTO3D_PACK_BTN_NOW')}</div>
                    </div>
                    <span className={style.packageButton}>{t('CHATAVATAR_BOARD_IMGTO3D_PACK_BTN')}</span>
                </div>
            </div>
            <div className={`${style.BundlePanelBox} ${showPayCard ? style.fadeIn : ''}`}>
                <BundlePanelFade onLikeChange={handleLike} />
            </div>
        </div>
    )
}

const GeneralUserTipBox = () => {
    const setShowSubscribe = useSetRecoilState(showSubscribeAtom)
    // const setShowReferral = useSetRecoilState(showReferralAtom)
    const setModalObj = useSetRecoilState(modalObjAtom)
    const { isCreatorOrAbove } = useContext(PermissionContext);
    const [showTipBox, setShowTipBox] = useState(true)
    const { t } = useTranslation();

    const openSubscribe = () => {
        setModalObj((pre) => {
            return {
                ...pre,
                state: false
            }
        })
        setShowSubscribe(true);
    }

    // const openReferral = () => {
    //     setModalObj((pre) => {
    //         return {
    //             ...pre,
    //             state: false
    //         }
    //     })
    //     setShowReferral(true)
    // }

    const handlerClose = () => {
        setShowTipBox(false)
    }

    if (!showTipBox || isCreatorOrAbove()) {
        return null
    }


    return (
        <div>
            <div className={style.generalUserTipBox}>
                <img onClick={handlerClose} src={deletWights} className={style.deletWights} alt="delete" />
                <div className={style.generalUserTipBoxContent}>
                    {t('CHATAVATAR_BOARD_IMGTO3D_NOSUB_TIPS_1')}.
                </div>
                <span className={style.subscribespan} onClick={openSubscribe}>{t('CHATAVATAR_BOARD_IMGTO3D_NOSUB_TIPS_2')}!</span>
            </div>
        </div>
    )
}

function DetailBoard({ width, type }) {
    const location = useLocation();
    const taskDetail = useRecoilValue(taskDetailAtom);
    const [isLike, setIsLike] = useState(taskDetail?.is_like || false);
    const [isPurchased, setIsPurchased] = useRecoilState(isPurchasedAtom);
    const modalObj = useRecoilValue(modalObjAtom);
    const logInfo = useRecoilValue(logInfoAtom);
    const cameraParams = useRecoilValue(cameraParamsAtom);
    // const packInfo = useRecoilValue(packInfoAtom);
    const setStopChat = useSetRecoilState(stopChatAtom);
    const setShowLogin = useSetRecoilState(showLoginAtom);
    const setProgressCheckingQueue = useSetRecoilState(progressCheckingQueueAtom);
    const setPackingState = useSetRecoilState(packingStateAtom);
    const [cards, setCards] = useRecoilState(cardsAtom);
    const [meshProfile, setMeshProfile] = useRecoilState(meshProfileAtom);
    const [showProgress, setShowProgress] = useRecoilState(showProgressAtom);
    const [showSharePopup, setShowSharePopup] = useRecoilState(showSharePopupAtom);
    const [showPayCard, setShowPayCard] = useRecoilState(showPayCardAtom);
    const [modelSelected, setModelSelected] = useState(false);
    const [fisrtEntry, setFisrtEntry] = useState(true);
    const modelRef = useRef(null);
    const promptRef = useRef(null);

    const handleLike = async (e, validLikeState) => {
        _czc.push(['_trackEvent', 'Card', 'Like Icon', 'Detail Card']);
        if (!logInfo) {
            setShowLogin(true);
            return;
        }
        const newCards = JSON.parse(JSON.stringify(cards));
        const index = cards.findIndex((item) => item.task_uuid === taskDetail.task_uuid)
        if (validLikeState && isLike) {
            if (index === -1) return;
            newCards[index].user_state = 'Generating';
            setPackingState('checking')
            setProgressCheckingQueue(pre => [...pre, { task_uuid: taskDetail.task_uuid, state: 'unchecked' }])
            setCards(newCards);
            return
        }
        try {
            setIsLike(!isLike);
            if (index === -1) return;
            newCards[index].is_like = !isLike;
            newCards[index].num_like = isLike ? taskDetail.num_like - 1 : taskDetail.num_like + 1;
            if (validLikeState) {
                newCards[index].user_state = 'Generating';
                setPackingState('checking')
                setProgressCheckingQueue(pre => [...pre, { task_uuid: taskDetail.task_uuid, state: 'unchecked' }])
            }
            setCards(newCards);
            likeCard({ task_uuid: taskDetail.task_uuid, operation: isLike ? 'Delike' : 'Like' })
        } catch (e) {
            Sentry.captureException(e)
        }
    };

    useEffect(() => {
        // console.log('Detailboard - Loading')
        setStopChat(true);
        const updateBodyClass = () => {
            if (window.isDraggingModel) {
                setModelSelected(true);
            } else {
                setModelSelected(false);
            }
        };
        window.addEventListener('mousedown', updateBodyClass);
        window.addEventListener('mouseup', updateBodyClass);

        return () => {
            // 	setStopChat(false)
            setShowPayCard(false);
            setIsPurchased(null)
            setShowSharePopup(false);
            setMeshProfile(false);
            window.removeEventListener('mousedown', updateBodyClass);
            window.removeEventListener('mouseup', updateBodyClass);
        };
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (taskDetail) {
            setShowProgress(false);
        }
        if (taskDetail && fisrtEntry) {
            const type = taskDetail.type === 'ImagineFace' ? 'imageto3d' : 'chatavatar'
            // handle url using Web History API. This is to make sure the url is correct when user refresh the page.
            const url = new URL(window.location.href)
            url.pathname = `/${type}/${taskDetail.task_uuid}`;

            // if (window.location.href !== url) {
            //     window.history.pushState({}, 0, url);
            // }
            setFisrtEntry(false)
        }
    }, [taskDetail]);

    const updateCamera = (intrinsic, extrinsic) => {
        if (window.static_project) {
            window.static_project.update_camera_from_calibration_matrix(
                intrinsic,
                extrinsic,
            );
        }
    };

    useEffect(() => {
        //console.log(cameraParams, 'cameraParams');
        setTimeout(() => {
            if (cameraParams && cameraParams.intrinsic && cameraParams.extrinsic) {
                updateCamera(cameraParams.intrinsic, cameraParams.extrinsic);
            }
        }, 50);
    }, [cameraParams]);

    const handleModelClick = (e) => {
        const elementUnderMouse = document.elementFromPoint(e.clientX, e.clientY);

        if (window.static_project && elementUnderMouse && elementUnderMouse.nodeName === 'CANVAS') {
            window.static_project.update_camera_from_calibration_matrix();
        }
    };

    function isDescendant(parent, child) {
        let node = child.parentNode;
        while (node != null) {
            if (node === parent) {
                return true;
            }
            node = node.parentNode;
        }
        return false;
    }

    const meshProfileChange = async () => {
        if (!meshProfile) return

        if (modalObj.type === "ImagineFace" && meshProfile.model_preview_info?.error) {
            setIsPurchased(false)
            // const targetWrapper = document.querySelector('#webglcontainer')
            // if (targetWrapper) {
            //     targetWrapper.replaceWith(document.createElement('div'));
            // }
            return
        }

        // 不同profile，先隐藏之前的
        if (window.static_project) {
            window.static_project.hide_scene();
        }

        const sourceObject = meshProfile.model_preview_info
        let urls = {};

        let targetKeys = {
            model: 'model',
            texture_diffuse: 'diffuse',
            texture_normal: 'normal',
            texture_specular: 'roughness'
        }

        if (modalObj.type !== "ImagineFace" && ['us-comic', 'cartoon'].includes(taskDetail?.settings?.style)) {
            targetKeys = {
                model: 'HEROmodel',
                texture_diffuse: 'HEROdiffuse',
                texture_normal: 'HEROnormal',
                texture_specular: 'roughness'
            }
        }

        for (const [key, value] of Object.entries(sourceObject)) {
            urls[targetKeys[key]] = value
        }

        // urls.model = 'https://hyperhuman-api.oss-cn-shanghai.aliyuncs.com/aad57310-3dca-4a08-903a-ee975cc7159a/model_refine/model.obj?OSSAccessKeyId=LTAI5tNZxAf5BugXvNFHe3BY&Expires=1716517971&Signature=laudvvKrH6mte6pVW2a1Wf0YFVI%3D&response-content-disposition=attachment%3B%20filename%3D%22model.obj%22&response-content-type=text%2Fplain'
        const options = taskDetail?.settings?.style
        setIsPurchased(true);

        if (window.static_project && document.querySelector('#webglcontainer')) {
            var container = document.querySelector('#webglcontainer');
            var contentContainer = window.static_project?.content?.container;

            if (contentContainer !== container && !isDescendant(contentContainer, container)) {
                if (contentContainer.parentNode !== container) {
                    container.appendChild(contentContainer);
                }
            } else {
                console.error("Cannot append container to itself or its descendant.");
            }
            window.static_project.options = options;
        }

        setShowProgress(false);
        global_render_target_injector.enabled = false;
        const webglContainer = document.querySelector('#webglcontainer')
        load_profile(urls, options, webglContainer, () => {
            window.last_uuid = meshProfile.task_uuid;
            if (window.static_project) {
                window.static_project.show_scene();
                if (modalObj.type === "DreamFace") {
                    window.static_project.update_camera_from_calibration_matrix();
                }
                window.static_project.lock_lights(['us-comic', 'cartoon'].includes(taskDetail?.settings?.style))
            }
        });
    };

    const debounceMesh = useDebounce(meshProfileChange, 200);

    useEffect(() => {
        debounceMesh();
    }, [meshProfile]);

    const compareDate = (create_time, default_time = '2023-07-01 00:00:00') => {
        const creatdate = new Date(create_time);
        const defaultdate = new Date(default_time);
        const create_timestamp = Math.floor(creatdate.getTime() / 1000);
        const default_timestamp2 = Math.floor(defaultdate.getTime() / 1000);
        return create_timestamp - default_timestamp2 >= 0;
    };

    // const GenmeTitle = () => {
    //     return (
    //         <div
    //             className={`${style.GenMeBox} ${style.largest}`}
    //             style={{
    //                 backgroundImage: `url(${genmebg})`,
    //             }}
    //         >
    //         </div>
    //     )
    // }

    return (
        <div
            className={`${style.detailBox} ${Math.random()}`}
            onPointerDown={handleModelClick}
            style={
                modelSelected
                    ? {
                        userSelect: 'none',
                        width,
                    }
                    : {
                        width,
                    }
            }
        >
            <div className={style.toolbarBox}>
                <CreatorInfo />
                <div className={style.spaceholder} />
                <ToolBar
                    isLike={isLike}
                    showSharePopup={showSharePopup}
                    setShowSharePopup={setShowSharePopup}
                    handleLike={handleLike} />
            </div>
            <div
                id='shareposter'
                style={{
                    position: 'absolute',
                    left: '53%',
                    top: '4rem',
                    transform: 'translate(-50%, 0)',
                    backgroundColor: 'white',
                    zIndex: 1000,
                    padding: 15,
                    borderRadius: 8,
                    boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
                    animation: 'fadeIn 0.3s',
                    visibility: showSharePopup ? '' : 'hidden',
                }}
            >
                {/*   waic={location.pathname.includes("/loreal") ? true : false} */}
                <ShareRender
                    type={taskDetail.type === 'ImagineFace' ? 'image' : 'text'}
                />
            </div>

            <div className={style.modelWrapper}>

                <div
                    className={style.modelView}
                    id="webglcontainer"
                    ref={modelRef}
                    data-cy="detail-model"
                    style={{ cursor: 'grab' }}
                ></div>
                {isPurchased === false && type === 'imageto3d' && (
                    <NoPack
                        showPayCard={showPayCard}
                        setShowPayCard={setShowPayCard}
                        handleLike={handleLike} />
                )}
                {isPurchased === null && <ModelLoading />}
                {/* seed */}
                {taskDetail?.settings?.seed && isPurchased && (
                    <div className={style.modelSeedsCon}>
                        <div className={style.seedsWrapper}>
                            <div className={`${style.modelSeeds}`} ref={promptRef} data-cy="detail-seed">
                                Seed
                                {' '}
                                {`${taskDetail?.settings?.seed}${compareDate(taskDetail.time) ? '' : '-old'}`}
                            </div>
                        </div>
                    </div>
                )}
                {taskDetail?.prompt && isPurchased && !taskDetail?.settings?.gen_me && (
                    <div className={style.modelPromptWrapper}>
                        <div className={`${style.modelPrompt}`} ref={promptRef} data-cy="detail-prompt">
                            {taskDetail?.prompt}
                        </div>
                    </div>
                )}

                {/* license */}
                {isPurchased && !showProgress && (
                    <div className={style.licenseBox}>
                        <License
                            largest
                            isLisenced={taskDetail.lisenced}
                            cancel={false}
                            uuid={taskDetail.task_uuid}
                        />
                    </div>
                )}
            </div>

        </div>
    );
}

export { DetailBoard };
